export default "__VITE_ASSET__WqDjjWpa__"